<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">Comentarios</div>
          <div class="title-sub">Historial de mensajes</div>
        </div>
        <div class="icon-btn" style="visibility: hidden;">
          <ion-icon name="close"></ion-icon>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="chat-bg" [fullscreen]="true">
    <div class="chat-container">

      <!-- Loading -->
      <div *ngIf="isLoading" class="loading-state">
        <ion-spinner name="crescent" color="primary"></ion-spinner>
      </div>

      <!-- Empty -->
      <div *ngIf="!isLoading && comentarios.length === 0" class="empty-state">
        <ion-icon name="chatbubbles-outline"></ion-icon>
        <p>Aún no hay mensajes</p>
        <span class="subtext">Agrega el primer comentario abajo</span>
      </div>

      <!-- Bubbles -->
      <div *ngIf="!isLoading && comentarios.length > 0" class="messages-list">
        <div class="message-wrapper" *ngFor="let c of comentarios"
          [ngClass]="{'mine': c.dt6 === usuarioActual, 'others': c.dt6 !== usuarioActual}">
          <div class="message-bubble">
            <div class="sender-name">
              {{ c.dt6 === usuarioActual ? 'Tú' : c.dt6 }}
            </div>
            <div class="message-text">
              {{ c.dt5 }}
            </div>
            <div class="message-meta">
              {{ c.dt2 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-content>

  <!-- Chat Input Footer -->
  <ion-footer class="ion-no-border">
    <ion-toolbar class="input-toolbar">
      <div class="input-container">
        <ion-textarea [(ngModel)]="nuevoComentario" placeholder="Escribe un comentario..." autoGrow="true" rows="1"
          maxRows="4" class="chat-input" [disabled]="isSending"></ion-textarea>

        <ion-button fill="clear" class="send-btn" (click)="enviarComentario()"
          [disabled]="isSending || !nuevoComentario || nuevoComentario.trim() === ''">
          <ion-icon name="send-sharp" slot="icon-only" *ngIf="!isSending"></ion-icon>
          <ion-spinner name="crescent" *ngIf="isSending"></ion-spinner>
        </ion-button>
      </div>
    </ion-toolbar>
  </ion-footer>
</div>
